import ToastManager from '@cb/solaris-react/Utility/ToastManager';
export class QuickToast {
    static success(message) {
        ToastManager.showSuccess({
            text: message,
            autoCloseMs: 3000,
        });
    }
    static error(message) {
        ToastManager.showError({
            text: message,
            autoCloseMs: 3000,
        });
    }
}
//# sourceMappingURL=QuickToast.js.map